import { useFlags } from "launchdarkly-react-client-sdk";

import { useHireJobRequisitionsFlag } from "./useHireJobRequisitionsFlag";

/**
 * The `hire-offer-management` LaunchDarkly release flag (the SDK camelCases the
 * key to `hireOfferManagement`).
 *
 * Gates every Offer Management frontend surface — the Offer section of
 * Application Management, the Settings tabs, and the offer rows in the Approvals
 * inbox. It is the release gate and is removed at GA, leaving the per-org
 * `OfferApprovalConfig.enabled` toggle as the sole control.
 *
 * Requires the requisitions flag as well: the Approvals inbox and the Approval
 * configuration page belong to job requisitions, so an offers-only org would
 * have an approval workflow with nowhere to action it.
 */
export const useHireOfferManagementFlag = (): boolean => {
  const { hireOfferManagement } = useFlags();
  const requisitionsEnabled = useHireJobRequisitionsFlag();
  return Boolean(hireOfferManagement) && requisitionsEnabled;
};
